import React, { memo } from 'react';
import styles from './LogEntry.module.css';

const LogEntry = memo(({ entry, index }) => {
  const getColorClass = (color) => {
    switch (color) {
      case 'cyan': return styles.cyan;
      case 'green': return styles.green;
      case 'yellow': return styles.yellow;
      case 'red': return styles.red;
      case 'teal': return styles.teal;
      default: return styles.white;
    }
  };

  const getTypeIcon = (type) => {
    switch (type) {
      case 'UPDATE':
        return '↻';
      case 'SECURE':
        return '✓';
      case 'ANALYSIS':
        return '⚡';
      case 'SCAN':
        return '◉';
      case 'CHECK':
        return '◎';
      case 'ALERT':
        return '⚠';
      case 'EXPLOIT':
        return '⚡';
      case 'BREACH':
        return '⚠';
      case 'PATCH':
        return '✓';
      default:
        return '•';
    }
  };

  const entryClasses = `${styles.logEntry} ${getColorClass(entry.color)}`;

  return (
    <div 
      className={entryClasses}
      style={{ animationDelay: `${index * 0.05}s` }}
      role="log"
      aria-label={`${entry.type} at ${entry.time}: ${entry.message}`}
    >
      <span className={styles.timestamp}>{entry.time}</span>
      <span className={styles.typeIcon}>{getTypeIcon(entry.type)}</span>
      <span className={styles.type}>[{entry.type}]</span>
      <span className={styles.message}>{entry.message}</span>
      
      {/* Special effects for certain entry types */}
      {entry.type === 'ALERT' && (
        <div className={styles.alertEffect}>
          <div className={styles.alertGlow}></div>
        </div>
      )}
      
      {entry.type === 'BREACH' && (
        <div className={styles.breachEffect}>
          <div className={styles.breachFlash}></div>
        </div>
      )}
      
      {entry.type === 'EXPLOIT' && (
        <div className={styles.exploitEffect}>
          <div className={styles.sparkle1}></div>
          <div className={styles.sparkle2}></div>
          <div className={styles.sparkle3}></div>
        </div>
      )}
    </div>
  );
});

LogEntry.displayName = 'LogEntry';

export default LogEntry;